import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/cn';
import { initialsOf } from '@/lib/initials';

interface InitialsAvatarProps {
  name: string;
  email: string;
  className?: string;
}

/** No avatar photos (RD §3.16): initials only. */
export function InitialsAvatar({ name, email, className }: InitialsAvatarProps): JSX.Element {
  return (
    <Avatar className={cn('h-8 w-8', className)}>
      <AvatarFallback className="bg-muted text-xs font-medium text-muted-foreground">{initialsOf(name, email)}</AvatarFallback>
    </Avatar>
  );
}
